module.exports = __webpack_public_path__ + "img/VP-Classic_Overview-Front_1.a90a577e.jpg";